module.exports = __webpack_public_path__ + "static/media/5.6fce6de0.JPG";